export default function LoadingSpinner() {
  return (
    <div className="d-flex justify-content-center py-5">
      <div className="spinner-border" style={{ color: 'var(--main-color)' }} />
    </div>
  );
}
